export default {
    ca: {
        heading: {
            title: 'Impressió del mapa',
            author: 'Autor',
        },
        body: {
            notes: 'Escriu aquí les teves anotacions...',
        },
        buttons: {
            print: 'Imprimir',
        },
    },
    es: {
        heading: {
            title: 'Impresión del mapa',
            author: 'Autor',
        },
        body: {
            notes: 'Escribe aquí tus anotaciones...',
        },
        buttons: {
            print: 'Imprimir',
        },
    },
    en: {
        heading: {
            title: 'Print map',
            author: 'Author',
        },
        body: {
            notes: 'Write your notes here...',
        },
        buttons: {
            print: 'Print',
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/print-modal/print-modal-translations.js